export default () => ({
    activeMediaTab: '',
    swiper: null,
    pressItemHeight: 0,
    swiperOptions: {
        direction: 'horizontal',
        loop: false,
        slidesPerView: 'auto',
        spaceBetween: 0,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
            dynamicBullets: true,
            dynamicMainBullets: 3,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        a11y: {
            enabled: true,
            slideRole: 'group',
            notificationClass: 'sr-only',
            scrollOnFocus: true,
        },
        watchSlidesProgress: true,
        touchEventsTarget: '.swiper-wrapper',
    },
    init() {
        let swiperEl = this.$el.querySelector('.swiper');

        this.swiper = new Swiper(swiperEl, this.swiperOptions);

        this.setSlideTab();

        this.swiper.on('slideChange', () => {
            this.setSlideTab();
        });

        // noinspection JSUnresolvedReference
        this.$watch('activeMediaTab', () => {
            this.goToActiveTabSlide();
        });

        // Добавляет класс swiper-buttons-disabled, если обе кнопки навигации неактивны
        this.swiper.on('slidesUpdated', function (swiper)  {
            if (swiper.navigation.nextEl && this.navigation.prevEl) {
                if (swiper.navigation.nextEl.classList.contains('swiper-button-disabled') &&
                    swiper.navigation.prevEl.classList.contains('swiper-button-disabled')) {
                    swiper.el.classList.add('swiper-buttons-disabled');
                } else {
                    swiper.el.classList.remove('swiper-buttons-disabled');
                }
            }
        });

        this.swiper.on('touchStart', function (swiper){
            swiper.el.classList.add('swiper-touching');
        });
        this.swiper.on('touchEnd', function (swiper){
            swiper.el.classList.remove('swiper-touching');
        });
        this.swiper.on('transitionStart', function (swiper){
            swiper.el.classList.add('swiper-transition');
        });
        this.swiper.on('transitionEnd', function (swiper){
            swiper.el.classList.remove('swiper-transition');
        });

        window.addEventListener("resize", () => {
            setTimeout(() => {
                this.swiper.update();
            }, 500);
        });

        // Подсчет минимальной высоты элементов прессы
        this.calculatePressItemHeight();
    },
    getActiveSlideTab() {
        const activeSlide = this.swiper.slides[this.swiper.activeIndex];
        return activeSlide.getAttribute('data-tab');
    },
    setSlideTab() {
        this.activeMediaTab = this.getActiveSlideTab()
    },
    goToActiveTabSlide() {
        const activeSlideTab = this.getActiveSlideTab();
        if (this.activeMediaTab === activeSlideTab) {
            return;
        }

        const slide = this.swiper.slides.find(slide => slide.getAttribute('data-tab') === this.activeMediaTab);
        if (!slide) {
            return;
        }

        const slideIndex = this.swiper.slides.indexOf(slide);

        this.swiper.slideTo(slideIndex);
    },
    calculatePressItemHeight(){

        // noinspection JSUnresolvedReference
        let samples = this.$root.querySelectorAll('.media-press-height-sample');

        let maxSampleHeight = 0;

        samples.forEach(sample => {
            let height = sample.offsetHeight;
            if (height > maxSampleHeight) {
                maxSampleHeight = height;
            }
        });

        this.pressItemHeight = maxSampleHeight;
    }
});
